import Vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios'

Vue.use(Vuex);

export default {
    namespaced: true,
    state: {
        states: {},
        brands: {},
        models: {},
        modelsNew: {},
        years: {},
        colors: {},
        brandsByAgency: {},
    },
    actions: {
        async getBrands({ commit }) {
            let { data } = await axios.get(`/api/find-car/brands-catalog?token=${process.env.MIX_TOKEN_WEBHOOK}`);
            const sortData = _.sortBy(data, 'name');
            sessionStorage.setItem('allBrands', JSON.stringify(sortData));
            commit('setBrands', sessionStorage.getItem('allBrands'));
        },

        async getModels({ commit }, brandId) {
            let { data } = await axios.get(`/api/find-car/models-catalog?token=${process.env.MIX_TOKEN_WEBHOOK}&brandId=${brandId}`);
            const sortData = _.sortBy(data, 'name');
            sessionStorage.setItem('allModels', JSON.stringify(sortData));
            commit('setModels', sessionStorage.getItem('allModels'));
        },
        async getModelsNew({ commit }, brandId) {
            let { data } = await axios.get(`${process.env.MIX_API_SUBASTALO_URL}/api/customer/brand-new-models?brand=${brandId}`);
            const sortData = _.sortBy(data, 'Nombre');
            sessionStorage.setItem('allModelsNew', JSON.stringify(sortData));
            commit('setModelsNew', sessionStorage.getItem('allModelsNew'));
        },
        async getYears({ commit }, params) {
            let { data } = await axios.get(`/api/find-car/years-catalog?token=${process.env.MIX_TOKEN_WEBHOOK}&brandId=${params.brandId}&modelId=${params.modelId}`);

            commit('setYears', data);
        },
        async getBrandsNewCarsByAgenciesHaveDealership({ commit }, stateId) {
            let { data } = await axios.get(`${process.env.MIX_API_SUBASTALO_URL}/api/marketplace/search-vehicle/brand-new/car-dealership/brands?state_id=${stateId}`);
            const sortData = _.sortBy(data, 'title');
            sessionStorage.setItem('allBrandsByAgency', JSON.stringify(sortData));
            commit('setBrandsByAgency', sessionStorage.getItem('allBrandsByAgency'));
        },
        async getColors({ commit }) {
            let { data } = await axios.get(`${process.env.MIX_API_SUBASTALO_URL}/api/customer/colors-marketplace`);
            const sortData = _.sortBy(data, 'name');
            commit('setColors', sortData);
        }
    },
    mutations: {
        setBrands(state, data) {
            state.brands = JSON.parse(data);
        },
        setModels(state, data) {
            state.models = JSON.parse(data);
        },
        setModelsNew(state, data) {
            state.modelsNew = JSON.parse(data);
        },
        setYears(state, data) {
            state.years = data
        },
        setColors(state, data) {
            state.colors = data
        },
        setBrandsByAgency(state, data) {
            state.brandsByAgency = JSON.parse(data);
        },
    }
}
